import { FieldTypeLink } from '@allesauto/utils/consts';
import {
  getUrlFromStoryblokLink,
  parseSlashToURL,
} from '@allesauto/utils/funcs';
import { sbEditable } from '@storyblok/storyblok-editable';
import React from 'react';

import Article, { ArticleProps } from './article/Article';
import TextLink from '../textLink';

export interface NewsTeaserProps {
  headline?: string;
  articles: ArticleProps[];
  linkLabel?: string;
  link?: FieldTypeLink;
  component: string;
  _uid: string;
  _editable?: string;
}

const NewsTeaser: React.FC<NewsTeaserProps> = (props) => {
  const { headline, articles, linkLabel, link } = props;

  const linkUrl = link && getUrlFromStoryblokLink(link);
  const className = {
    wrapper: 'bg-white grid grid-cols-24 py-30px lg:py-60px',
    headline:
      'col-end-24 col-start-2 font-headline pb-10px text-grey100 text-headline2 lg:col-end-21 lg:col-start-2 lg:pb-20px',
    textLink:
      'col-end-24 col-start-2 mt-10px lg:col-start-21 lg:pb-40px lg:row-end-2 lg:row-start-1 lg:justify-self-end',
    articleList:
      'col-end-24 col-start-2 lg:col-span-full lg:grid lg:grid-cols-3',
  };

  return (
    <div {...sbEditable(props)} className={className.wrapper}>
      {headline && <h2 className={className.headline}>{headline}</h2>}
      <div className={className.articleList}>
        {articles.map((article, key) => (
          <Article key={`article-${key}`} {...article} />
        ))}
      </div>
      {linkLabel && linkUrl && (
        <TextLink
          text={linkLabel}
          href={parseSlashToURL(linkUrl)}
          target={link.target ?? '_self'}
          customClassName={className.textLink}
        />
      )}
    </div>
  );
};

export default NewsTeaser;
